/** @jsx jsx */
import { Flex } from "@eworkit/iris";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { FC } from "react";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { RelatedEntities } from "@/data/related";

import { useRelatedEntitiesNav } from "./RelatedEntitiesNavContext";
import { RelatedEntitiesTabButton } from "./RelatedEntitiesTabButton";
import { RelatedEntitiesTabSelect } from "./RelatedEntitiesTabSelect";

export interface RelatedEntitiesMenuProps {
  relatedEntities: RelatedEntities;
}

export const RelatedEntitiesMenu: FC<RelatedEntitiesMenuProps> = ({ relatedEntities }) => {
  const breakpoint = useBreakpointIndex();

  const { keys } = useRelatedEntitiesNav();

  if (breakpoint >= 3) {
    return (
      <ResponsiveCard>
        <Flex flexDirection="column">
          {keys.map(key => (
            <RelatedEntitiesTabButton key={key} relatedKey={key} relatedEntities={relatedEntities} />
          ))}
        </Flex>
      </ResponsiveCard>
    );
  } else {
    return (
      <ResponsiveCard sx={{ py: ["sm", "sm", "sm"] }}>
        <RelatedEntitiesTabSelect relatedEntities={relatedEntities} />
      </ResponsiveCard>
    );
  }
};
